export default["__VITE_ASSET__DrWR2Wa5__","__VITE_ASSET__G8547GFq__"];